import { Link } from "@tanstack/react-router";
import { AlertTriangle } from "lucide-react";
import { useInbox, useInboxRealtime } from "@/lib/hooks/useNotifications";

/** Alertas de integracao ativos no topo do app (credencial recusada, destino
 *  perdido). Queda de conexao ja aparece no ConnectionDropAlert, ao vivo. */
export function IntegrationAlerts(): JSX.Element | null {
  useInboxRealtime();
  const { data: inbox } = useInbox();
  const alerts = (inbox?.activeAlerts ?? []).filter((alert) => alert.kind !== "connection_down");
  if (alerts.length === 0) return null;

  return (
    <div className="space-y-2" role="region" aria-label="Alertas das integrações">
      {alerts.map((alert) => (
        <div key={alert.id} role="alert" className="flex flex-wrap items-center justify-between gap-2 rounded-lg border border-destructive/40 bg-destructive/5 px-4 py-2.5 text-sm">
          <span className="flex min-w-0 items-center gap-2 text-foreground">
            <AlertTriangle size={15} className="shrink-0 text-destructive" aria-hidden="true" />
            {alert.title}
          </span>
          {alert.actionUrl && (
            <Link to={alert.actionUrl} className="text-xs font-semibold text-primary underline-offset-4 hover:underline">
              Resolver
            </Link>
          )}
        </div>
      ))}
    </div>
  );
}
